export default class Parallax {
    constructor(controller) {
        this.controller = controller;
        this.init();
    }

    init() {
        this.parallax();
    }

    parallax() {
        gsap.registerPlugin(ScrollTrigger);

        gsap.utils.toArray('.js-parallax').forEach((wrap) => {
            const y = wrap.getAttribute('data-y') || -80;

            gsap.to(wrap, {
                y: y,
                scrollTrigger: {
                    trigger: wrap,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 1.0,
                },
            });
        });
    }
}
